import { useBreakpointV2 } from "@tm/ui-widgets";
import { DesktopLayout, FlexComp, Shimmer } from "@tm/ui-widgets/components";
import React from "react";
import TravellingToShimmer from "../../components/TravelDetails/TravellingToShimmer";
//import Header from 'gi-happy-header/ssr/header';
//import { Header  } from 'pwa-mmt-ui-header/ssr/header';

const InsuranceLandingShimmer = () => {
  const device = useBreakpointV2();
  return (
    <React.Fragment>
      {/* <LandingHeader loginState /> */}

      {/* <Header /> */}
      {/* <Header.HappyHeader
			lobName="flights"
			onLoginSuccess={() => console.log('login successfull')}
			onLogoutSuccess={() => console.log('logout successfull')}
			sticky={true}
		/> */}
      <DesktopLayout
        alignCenter
        rightSectionHeight="unset"
        leftSectionHeight
        landingMargin
        leftComp={
          <React.Fragment>
            <FlexComp gap="8px" flexDirection="column">
              <Shimmer
                height="55px"
                width={device == "lg" ? "375px" : "100px"}
              />
              <Shimmer height="55px" width="100%" />
            </FlexComp>
            <Shimmer
              height={device == "lg" ? "20px" : "10px"}
              width={device == "lg" ? "248px" : "100%"}
            />
            <Shimmer height={device == "lg" ? "80px" : "40px"} width="100%" />
            <Shimmer height={device == "lg" ? "80px" : "40px"} width="100%" />
          </React.Fragment>
        }
        rightComp={<TravellingToShimmer />}
      ></DesktopLayout>
    </React.Fragment>
  );
};

export default InsuranceLandingShimmer;
